export enum SettingsGroup {
    view = 'view',
    similar = 'similar',
}

export enum RadarView {
    default = 'default',
    similar = 'similar',
}
